const transforms = require('./transforms');
module.exports = {
  credentials: {
    appId: 'O3F8QXYK6R',
    apiKey: '0882cc05e53dfecb0701f19d45fc0340',
    indexName: 'gamemaster_npcs',
  },
  hitName: 'character',
  placeholder: 'Search for any adjective',
  sidebar: [
    {
      title: 'Faction',
      options: {
        attribute: 'faction',
      },
    },
    {
      title: 'Traits',
      options: {
        attribute: 'traits',
        limit: 15,
        searchable: true,
        searchablePlaceholder: 'Search for an NPC trait...',
        showMore: true,
        showMoreLimit: 1000,
      },
    },
  ],
  transforms,
};
